import React, { useEffect, useState } from 'react';
import { X, Loader2, PhoneCall, Search } from 'lucide-react';
import { api } from '../context/AuthContext';

const inp = 'w-full border border-gray-200 px-3 py-2 text-sm text-[#1B3A5C] focus:outline-none focus:border-[#b8893d]';
const Lbl = ({ children }) => <span className="block mb-1 text-[10px] tracking-[0.15em] uppercase text-[#7a8a99]">{children}</span>;
const DRING = [['normal', 'Normal'], ['dringend', 'Dringend'], ['sehr_dringend', 'Sehr dringend']];
const BEREICH = [['beides', 'Beides / unklar'], ['recht', 'Rechtsfall'], ['steuern', 'Steuerberatung']];

const MandantWahl = ({ onWahl }) => {
  const [q, setQ] = useState('');
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (q.trim().length < 2) { setItems([]); return undefined; }
    const t = setTimeout(() => api.get('/cases/neuer-chat/suche', { params: { q: q.trim() } }).then((r) => setItems(r.data.items || [])).catch(() => setItems([])), 300);
    return () => clearTimeout(t);
  }, [q]);
  return (
    <div className="col-span-2 relative">
      <Lbl>Mandant (optional)</Lbl>
      <div className="flex items-center gap-2 border border-gray-200 px-3 py-2 focus-within:border-[#b8893d]">
        <Search className="w-3.5 h-3.5 text-[#7a8a99]" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Name, M-Nr oder E-Mail – oder leer lassen" className="flex-1 text-sm focus:outline-none" data-testid="neuer-rueckruf-mandant-search" />
      </div>
      {items.length > 0 && (
        <ul className="absolute z-10 left-0 right-0 bg-white border border-gray-200 shadow-lg max-h-48 overflow-y-auto">
          {items.map((m) => (
            <li key={m.mandanten_nr}><button type="button" onClick={() => { onWahl(m); setQ(''); setItems([]); }} data-testid={`neuer-rueckruf-mandant-${m.mandanten_nr}`}
              className="w-full text-left px-3 py-2 text-xs hover:bg-[#fbf7f0]"><span className="text-[#1B3A5C]">{m.name}</span> <span className="font-mono text-[#7a8a99]">M-{m.mandanten_nr}{m.telefon ? ` · ${m.telefon}` : ''}</span></button></li>
          ))}
        </ul>
      )}
    </div>
  );
};

export const NeuerRueckrufDialog = ({ user, onClose, onDone }) => {
  const [f, setF] = useState({ mandanten_nr: '', case_id: '', name: '', telefon: '', email: '', anliegen: '', dringlichkeit: 'normal', bereich: 'beides', zustaendig_user_id: user?.user_id || '' });
  const [mandant, setMandant] = useState(null);
  const [team, setTeam] = useState([]);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  useEffect(() => { api.get('/team/rueckrufe/mitglieder').then((r) => setTeam(r.data.items || [])).catch(() => {}); }, []);
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));
  const wahl = (m) => { setMandant(m); setF((p) => ({ ...p, mandanten_nr: m.mandanten_nr, case_id: '', name: m.name, telefon: m.telefon || p.telefon, email: m.email || '' })); };

  const speichern = async () => {
    setBusy(true); setErr('');
    try { const r = await api.post('/team/rueckrufe', f); onDone(r.data.rueckruf); }
    catch (e) { setErr(e?.response?.data?.detail || 'Speichern fehlgeschlagen'); }
    setBusy(false);
  };

  return (
    <div className="fixed inset-0 z-[60] bg-black/40 flex items-center justify-center p-4" onClick={onClose} data-testid="neuer-rueckruf-dialog">
      <div className="bg-white w-full max-w-lg shadow-xl max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100">
          <span className="inline-flex items-center gap-2 text-sm font-semibold text-[#1B3A5C]"><PhoneCall className="w-4 h-4 text-[#b8893d]" /> Neuer Rückruf</span>
          <button type="button" onClick={onClose} aria-label="Schließen" data-testid="neuer-rueckruf-close"><X className="w-4 h-4 text-[#7a8a99]" /></button>
        </div>
        <div className="p-5 grid grid-cols-2 gap-3">
          {mandant ? (
            <div className="col-span-2 flex items-center gap-2 px-3 py-2 bg-[#fbf7f0] text-xs" data-testid="neuer-rueckruf-mandant-gewaehlt">
              <span className="text-[#1B3A5C] font-medium">{mandant.name}</span><span className="font-mono text-[#7a8a99]">M-{mandant.mandanten_nr}</span>
              <button type="button" onClick={() => { setMandant(null); setF((p) => ({ ...p, mandanten_nr: '', case_id: '' })); }} className="ml-auto text-[#7a8a99] hover:text-rose-600" data-testid="neuer-rueckruf-mandant-entfernen"><X className="w-3.5 h-3.5" /></button>
            </div>
          ) : <MandantWahl onWahl={wahl} />}
          {mandant?.akten?.length > 0 && (
            <label className="col-span-2"><Lbl>Akte (optional)</Lbl>
              <select value={f.case_id} onChange={set('case_id')} className={inp} data-testid="neuer-rueckruf-akte">
                <option value="">Ohne Akte</option>
                {mandant.akten.map((a) => <option key={a.id} value={a.id}>{a.aktenzeichen ? `AZ ${a.aktenzeichen}` : a.rechtsgebiet}</option>)}
              </select>
            </label>
          )}
          <label><Lbl>Name</Lbl><input value={f.name} onChange={set('name')} className={inp} data-testid="neuer-rueckruf-name" /></label>
          <label><Lbl>Telefon</Lbl><input value={f.telefon} onChange={set('telefon')} className={inp} data-testid="neuer-rueckruf-telefon" /></label>
          <label className="col-span-2"><Lbl>Anliegen</Lbl><textarea rows={3} value={f.anliegen} onChange={set('anliegen')} className={inp} data-testid="neuer-rueckruf-anliegen" /></label>
          <label><Lbl>Dringlichkeit</Lbl><select value={f.dringlichkeit} onChange={set('dringlichkeit')} className={inp} data-testid="neuer-rueckruf-dringlichkeit">{DRING.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select></label>
          <label><Lbl>Bereich</Lbl><select value={f.bereich} onChange={set('bereich')} className={inp} data-testid="neuer-rueckruf-bereich">{BEREICH.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select></label>
          <label className="col-span-2"><Lbl>Zuständig</Lbl>
            <select value={f.zustaendig_user_id} onChange={set('zustaendig_user_id')} className={inp} data-testid="neuer-rueckruf-zustaendig">
              {team.length === 0 && <option value={user?.user_id}>{`${user?.name || ''} (ich)`}</option>}
              {team.map((t) => <option key={t.user_id} value={t.user_id}>{`${t.name || t.email}${t.user_id === user?.user_id ? ' (ich)' : ''}`}</option>)}
            </select>
          </label>
          {err && <p className="col-span-2 px-2 py-1 text-xs text-red-700 bg-red-50" data-testid="neuer-rueckruf-error">{err}</p>}
        </div>
        <div className="flex justify-end px-5 py-3 border-t border-gray-100">
          <button type="button" onClick={speichern} disabled={busy || !f.name.trim() || !f.telefon.trim() || !f.anliegen.trim()} data-testid="neuer-rueckruf-speichern"
            className="inline-flex items-center gap-1.5 px-4 py-2 text-[11px] tracking-wider bg-[#1B3A5C] text-white hover:bg-[#b8893d] transition-colors disabled:opacity-40">
            {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <PhoneCall className="w-3.5 h-3.5" />} RÜCKRUF ANLEGEN
          </button>
        </div>
      </div>
    </div>
  );
};
